
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/town",
      function () {
        return require("private-next-pages/town/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/town"])
      });
    }
  